import React, { Fragment } from "react";

import { getTestIdForPriority } from "@common/components/DetailsBar/getDetailsBarTestIdentifiers";
import { DropdownItem } from "@common/components/Dropdown/Dropdown";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { TicketPriority } from "@common/models/TicketPriority.model";
import { getPriorityIcon } from "@common/util/getIconsHelper";
import identifiers from "@common/util/identifiers.json";

import * as Styled from "./PriorityDropdown.styles";

interface PriorityDropdownProps {
  priority: TicketPriority;
  isOpened: boolean;
  setIsOpened: (isOpened: boolean) => void;
  changePriority: (priority: TicketPriority) => void;
}

export const PriorityDropdown = ({ priority, isOpened, setIsOpened, changePriority }: PriorityDropdownProps) => {
  return (
    <Tooltip
      style={{ width: "auto" }}
      position="top"
      text="Set priority"
    >
      <Styled.Dropdown
        label={priority}
        iconComponent={<Styled.IconContainer>{getPriorityIcon(priority)}</Styled.IconContainer>}
        buttonElement={<Fragment />}
        position="left"
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        testId={identifiers["central.column.priority.button"]}
      >
        {Object.values(TicketPriority).map((priority) => {
          return (
            <DropdownItem
              key={priority}
              onClick={() => {
                changePriority(priority);
                setIsOpened(false);
              }}
              testId={getTestIdForPriority(priority)}
            >
              <Styled.IconContainer>{getPriorityIcon(priority)}</Styled.IconContainer>
              {priority}
            </DropdownItem>
          );
        })}
      </Styled.Dropdown>
    </Tooltip>
  );
};
